import { StandardModePadding } from "@/app/outlets/StandardModePadding";
import { NotFoundPage } from "@/pages/not-found";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Outlet } from "react-router-dom";

interface RequireDebugModeOutletProps {}

export const RequireDebugModeOutlet: FC<RequireDebugModeOutletProps> = observer(() => {
  const { store } = useAppStore();

  if (!store.debug.debugModeEnabled) {
    return (
      <StandardModePadding>
        <NotFoundPage />
      </StandardModePadding>
    );
  }

  return <Outlet />;
});
